//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImagePreview from "./ImagePreview";
export default {
  data() {
    return {
      activeName: "first",
      activeNameT: "first",
      landInfo: {
        croplandVillGroupName: "四川剑阁县恒禾智慧农场",
        address: "四川剑阁县",
        croplandFranchisedTypeName: "土地流转",
        croplandProprietor: "夏卫华",
        croplandId: "0012",
        croplandTypeName: "耕地",
        croplandPerimeter: "125",
        croplandArea: "25",
      }, // 地块切卡的地块信息（地图右侧信息）
      workInfo: {}, // 地块切卡的作业信息（地图右侧信息）
      auditInfo: [], // 地块切卡的审核信息（地图右侧信息）
      previewSrc: "",
      previewSrcList: [],
      trajectoryInfo: {}, //轨迹的信息（地图右侧信息）
      trajectoryBlockInfo: [], //轨迹的地块信息（地图右侧信息）
      assignDetail: {}, // 派活信息（地图右侧信息）
    };
  },
  components: { ImagePreview },
  props: ["landId"],
  watch: {
    landId() {
      this.getLandMsg();
    },
  },
  mounted() {
    this.getLandMsg();
  },
  methods: {
    // 预览图片
    handlePreviewImg(data) {
      this.previewSrcList = data;
      this.$refs.previewImg.showViewer = true;
    },
    getLandMsg() {
      console.log('地块');

      this.landInfo = {};
      if (this.landId) {
        // this.$http.work.getLandDetail({ id: this.landId }).then((res) => {
        //   this.landInfo = res.data;
        // });
        // this.$http.work.getWorkLandDetails({ workLandId: this.landId }).then((res) => {
        //   this.workInfo = res.data;
        // });
      }
    },
  },
};
